<template>
  <div>
    <b-dropdown variant="link" size="sm" right no-caret @show="openNotificationsDropDown">
      <template slot="button-content">
        <icon name="bell" class="notifications__icon"></icon>
        <div class="notifications__counter">
          {{notificationsCount}}
        </div>
      </template>
      <b-dropdown-header class="notifications__dropdown__header">
        {{$t('labels.common.notifications')}}
        <div @click="deleteAllNotifications" class="notifications__dropdown__icons_delete">
          <icon name="trash"></icon>
        </div>
      </b-dropdown-header>
      <div class="notifications-list" v-if="notificationsList.length">
        <div v-for="notification in notificationsList" :key="notification.id" class="notification__wrapper">
          <div class="dropdown-item">
            <div v-html="notification.messageHTML"></div>
            <div class="notification-date">
              {{notification.timestamp}}
            </div>
          </div>
          <div class="notification__icon_delete" @click="deleteNotification(notification.id)">
            <icon name="times"></icon>
          </div>
          <b-dropdown-divider></b-dropdown-divider>
        </div>
      </div>
      <div v-else-if="!notificationsCount" class="dropdown-item">
        {{$t('notifications.common.no_unread_notifications')}}
      </div>
      <div v-else class="dropdown-item">{{$t('system_messages.loading')}}</div>
    </b-dropdown>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { handlerResponse } from '@/helpers/commonHelpers';

  export default {
    data() {
      return {
        notificationsList: []
      }
    },
    methods: {
      openNotificationsDropDown() {
        this.loadNotificationsList();
      },
      deleteNotification(currentNotificationId) {
        this.$http.delete(`generic/notifications/${currentNotificationId}/`).then(() => {
          this.loadNotificationsList();
        })
      },
      deleteAllNotifications() {
        if (this.notificationsList.length) {
          this.$http.delete(`generic/notifications/`).then(() => {
            this.loadNotificationsList();
          });
        }
      },
      loadNotificationsList() {
        if (this.notificationsCount !== 0) {
          this.$http.get(`generic/notifications/`).then(handlerResponse).then((response) => {
            this.notificationsList = response.map(item => this.generateNotificationText(item));
            const notificationsCount = this.notificationsList.length;
            this.$store.commit('generic/setNotificationsCount', notificationsCount);
          });
        }
      },
      generateNotificationText(notification) {
        const windowLocationUrl = window.location.origin;
        let currentUrl;
        currentUrl = `${windowLocationUrl}${notification.link}`;
        const splittingArrayByString = notification.message.split('{link_text}');
        notification.messageHTML = `<span>${splittingArrayByString[0]}
            <a href="${currentUrl}" class="notification-link">${notification.link_text}</a>
            ${splittingArrayByString[1]}</span>`;

        return notification;
      }
    },
    computed: {
      ...mapGetters('generic', ['notificationsCount'])
    }
  }
</script>

<style>
  .notifications__icon {
    width: 26px;
    height: 26px;
    color: #364868;
  }

  .notifications__counter {
    height: 20px;
    min-width: 20px;
    border-radius: 50%;
    border: 1px solid #fff;
    background: #d3d6e0;
    color: #061c4e;
    font-size: 11px;
    position: absolute;
    top: 8px;
    right: 12px;
    text-align: center;
    padding-top: 1px;
  }

  .notification-date {
    font-size: 11px;
    margin-top: 3px;
  }

  .notification__wrapper {
    position: relative;
  }

  .notification__wrapper .dropdown-divider {
    margin: 0;
  }

  .notifications__wrapper .btn-link {
    padding: 0;
  }

  .notifications__wrapper .notifications__dropdown__header header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background: #77818b;
    color: #fff;
    padding: 10px 23px 10px 10px;
  }

  .notifications__wrapper .dropdown-menu {
    width: 350px;
    transform: none !important;
    top: 30px !important;
    left: inherit !important;
    right: 0 !important;
  }

  .notifications__wrapper .dropdown-menu .dropdown-item {
    width: auto;
    min-height: 35px;
    height: auto;
    box-sizing: initial;
    font-size: 13px;
    position: relative;
    padding: 10px 35px 10px 10px;
    word-break: break-all;
    white-space: normal !important;
    cursor: inherit;
  }

  .notifications__wrapper .dropdown-menu .dropdown-item:hover,
  .notifications__wrapper .dropdown-menu .dropdown-item:active {
    background-color: #f8f9fa;
    color: #212529;
  }

  .notifications-list {
    max-height: 170px;
    overflow-y: auto;
    background: #fff;
  }

  .notification__icon_delete {
    position: absolute;
    top: 2px;
    right: 8px;
    cursor: pointer;
    color: #77818b;
  }

  .notifications__dropdown__icons_delete {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Notifications.vue